<template>
<div>
    <p class="data-tip"><i class="iconfont">&#xe654;</i>本页面榜单排行取近1年的数据，按照投融资事件数量多少排列。</p>
    <div class="financing_data">
        <!-- 最新Top30 投资机构Top30 -->
        <div class="list_div">
            <Table :columns="columns" :data="list"></Table>
        </div>
        <Contanct :page="3"></Contanct>
        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import { orgTop } from '../../../../service'
export default {
  inject: ['login'],
  components: {
    Contanct
  },
  data() {
    return {
      spinShow: true,
      list: [],
      columns: [
        { title: '排名',width: 150, align: 'center',render: (h, params) => {
          if(params.row.rank_num < 4) {
            return h('img', { attrs: {src: require('../../../../assets/pic/top'+params.row.rank_num+'.png')}})
          }else{
            return h('span', params.row.rank_num)
          }
        }},
        { title: '投资机构',width: 320, render:(h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                on: {click: () => {
                  if (this.$store.state.user_key) {
                    this.goEntityDetail(params.row.uid)
                  } else {
                    this.login()
                  }
                }},
                class: {logo_img: true}
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('div',{class: {company_info: true}}, [
                  h('p', [
                    h('a',{
                      on: {click: () => {
                        if (this.$store.state.user_key) {
                          this.goEntityDetail(params.row.uid)
                        } else {
                          this.login()
                        }
                      }}
                    }, params.row.short_name)
                  ])
                  // h('p' ,filter.empty(params.row.ht_description,'暂无描述')),
                ])
              ])
          ])
        }},
        { title: '投融资事件数',width: 180, render:(h, params) => {
          return h('span', params.row.event_num)
        }},
        { title: '关注领域',minWidth: 220, render:(h, params) => {
            if (params.row.tags != '') {
              return h('div', {class: {'dec-clamp': true}}, filter.dealString(params.row.tags, 'dynview_tag'))
            } else {
              return h('span', '--')
            }
        }}
      ]
    }
  },
  methods: {
    async getList() {
      let res = await orgTop({}, (error) => { this.$Message.error('请求错误！') })
      if(res.status == 'success') {
        this.list = res.res
        this.spinShow = false
      } else {
        this.$Message.error(res.message)
      }
    },
    goEntityDetail(uid) {
      // this.$router.push({name:'OrgDetail',params: {uid:uid}})
      const { href } = this.$router.resolve({
        name: "OrgDetail",
        params: {
          uid: uid
        }
      })
      window.open(href, '_blank')
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.financing_data .list_div
  padding-top: 0
  & >>> .ivu-table-wrapper
  .ivu-table
    tr
      td:first-of-type
      th:first-of-type
        .ivu-table-cell
          padding-right: 56px !important
</style>
